import { ModalCustom } from "components/ModalCustom";
import {
  ContainerFechar,
  ContainerForm,
  ContainerTexto,
  UploadContainer,
} from "./style";
import { IDadosCriarLote } from "../../../../interfaces/IDadosCriarLote";
import { Col, Form, Row } from "react-bootstrap";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import temaPadrao from "_config/temas/estilo/base";
import { Required } from "components/Required";
import FileUpload from "components/UploadArquivos";
import { PrimaryButton } from "components/Button/style";
import { FaDownload } from "react-icons/fa";
import { useDivisoes } from "hooks/useDivisoes";
import { useCentroCusto } from "hooks/useCentroCusto";
import { useParceirosDespachante } from "hooks/useParceirosDespachante";
import { useCallback, useRef } from "react";

interface IProps {
  show: boolean;
  dadosCriarLote: IDadosCriarLote;
  setDadosCriarLote: (dados: IDadosCriarLote) => void;
  handleClose: () => void;
  onClickProsseguir: () => void;
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function ModalCriarLote({
  show,
  dadosCriarLote,
  handleClose,
  setDadosCriarLote,
  onClickProsseguir,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IProps) {
  const dadosCriarLoteRef = useRef(dadosCriarLote);
  dadosCriarLoteRef.current = dadosCriarLote;

  const { divisoesOptions } = useDivisoes(dadosCriarLote.empresa);
  const { centrosCustoOptions, solicitantesOptions } = useCentroCusto(
    dadosCriarLote.empresa,
    dadosCriarLote.centroCusto,
  );
  const idDespachanteAw = 0;
  const { parceirosOptions } = useParceirosDespachante(idDespachanteAw);

  const listarCnpjsRef = useRef(listarCnpjsIntegracaoFrotista);
  listarCnpjsRef.current = listarCnpjsIntegracaoFrotista;

  const handleSelectEmpresa = useCallback(
    (value: any) => {
      const obj: IDadosCriarLote = {
        ...dadosCriarLoteRef.current,
        empresa: Number(value ?? 0),
      };

      if (!value) {
        obj.divisao = 0;
        obj.centroCusto = 0;
        obj.solicitante = 0;
        obj.cnpj = "";
      }

      const dadosEmpresa = empresasOptions.find(
        (empresa) => value && empresa.value == value,
      );

      obj.nomeEmpresa = dadosEmpresa ? dadosEmpresa.label : "";

      setDadosCriarLote(obj);
      listarCnpjsRef.current(Number(value ?? 0));
    },
    [empresasOptions],
  );

  const handleSelectDivisao = useCallback(
    (value: any) => {
      const obj: IDadosCriarLote = {
        ...dadosCriarLoteRef.current,
        divisao: Number(value ?? 0),
      };

      const dadosDivisao = divisoesOptions.find(
        (divisao) => value && divisao.value == value,
      );

      obj.nomeDivisao = dadosDivisao ? dadosDivisao.label : "";
      setDadosCriarLote(obj);
    },
    [divisoesOptions],
  );

  const handleSelectCentroCusto = useCallback(
    (value: any) => {
      const obj: IDadosCriarLote = {
        ...dadosCriarLoteRef.current,
        centroCusto: Number(value ?? 0),
      };

      if (!value) {
        obj.solicitante = 0;
      }

      const dadosCentroCusto = centrosCustoOptions.find(
        (centroCusto) => value && centroCusto.value == value,
      );

      obj.nomeCentroCusto = dadosCentroCusto ? dadosCentroCusto.label : "";

      setDadosCriarLote(obj);
    },
    [centrosCustoOptions],
  );

  const handleSelectSolicitante = useCallback(
    (value: any) => {
      const obj: IDadosCriarLote = {
        ...dadosCriarLoteRef.current,
        solicitante: Number(value ?? 0),
      };

      const dadosSolicitante = solicitantesOptions.find(
        (solicitante) => value && solicitante.value == value,
      );

      obj.nomeSolicitante = dadosSolicitante ? dadosSolicitante.label : "";

      setDadosCriarLote(obj);
    },
    [solicitantesOptions],
  );

  const handleSelectCnpj = useCallback((value: any) => {
    setDadosCriarLote({ ...dadosCriarLoteRef.current, cnpj: value ?? "" });
  }, []);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={
        dadosCriarLote.tipo === "bloquear"
          ? "Bloquear veículos"
          : "Desbloquear veículos"
      }
      centered
      footer
      size="lg"
      footerTools={
        <ContainerFechar>
          <PrimaryButton
            outline
            variante="primary"
            type="button"
            onClick={() => {
              const link = document.createElement("a");
              link.download = "modelo_bloqueio_admininstrativo.xlsx";
              link.href = "/app/files/modelo_bloqueio_admininstrativo.xlsx";
              link.click();
            }}
          >
            Baixar modelo <FaDownload />
          </PrimaryButton>
          <PrimaryButton
            onClick={handleClose}
            outline={true}
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            onClick={onClickProsseguir}
            variante="primary"
            disabled={
              !dadosCriarLote.empresa ||
              !dadosCriarLote.divisao ||
              !dadosCriarLote.cnpj ||
              !dadosCriarLote.arquivo
            }
          >
            Prosseguir
          </PrimaryButton>
        </ContainerFechar>
      }
    >
      <ContainerTexto>
        Preencha os campos abaixo para realizar o{" "}
        {dadosCriarLote.tipo === "bloquear" ? "bloqueio" : "desbloqueio"} dos
        veículos.
      </ContainerTexto>
      <ContainerForm>
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Empresa <Required />
              </Form.Label>
              <DropdownSelect
                options={empresasOptions}
                title=""
                selectedValue={dadosCriarLote.empresa}
                onSelect={handleSelectEmpresa}
                searchable
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Divisão <Required />
              </Form.Label>
              <DropdownSelect
                options={divisoesOptions}
                title=""
                selectedValue={dadosCriarLote.divisao}
                onSelect={handleSelectDivisao}
                searchable
                required
                disabled={!dadosCriarLote.empresa}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Centro de custo
              </Form.Label>
              <DropdownSelect
                options={centrosCustoOptions}
                title=""
                selectedValue={dadosCriarLote.centroCusto}
                onSelect={handleSelectCentroCusto}
                searchable
                disabled={!dadosCriarLote.empresa}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Solicitante
              </Form.Label>
              <DropdownSelect
                options={solicitantesOptions}
                title=""
                selectedValue={dadosCriarLote.solicitante}
                onSelect={handleSelectSolicitante}
                searchable
                disabled={!dadosCriarLote.centroCusto}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                CNPJ <Required />
              </Form.Label>
              <DropdownSelect
                title=""
                options={cnpjsOptions}
                selectedValue={dadosCriarLote.cnpj}
                onSelect={handleSelectCnpj}
                disabled={!dadosCriarLote.empresa}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <UploadContainer>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Upload do arquivo .xlsx <Required />
                </Form.Label>
                <FileUpload
                  onFileUpload={(arquivo) => {
                    setDadosCriarLote({
                      ...dadosCriarLoteRef.current,
                      arquivo: arquivo ?? null,
                    });
                  }}
                  inputAccept="xlsx"
                />
              </UploadContainer>
            </Form.Group>
          </Col>
        </Row>
      </ContainerForm>
    </ModalCustom>
  );
}
